import { createProviderToken } from '@core/common-legacy';
import { ReportsBreadcrumbsDirector } from '@core/reports-types';

export const { inject: injectBreadcrumbsFacade, provide: provideBreadcrumbsFacade } =
  createProviderToken<ReportsBreadcrumbsDirector>('ReportsBreadcrumbsDirectorService')();
